import { Box } from "@/components/core-components";
import { ShapeIcon, Typography } from "@flash-tecnologia/hros-web-ui-v2";

interface MigrateAccordionHeaderProps {
  canMigrate?: boolean;
}

export const MigrateAccordionHeader = ({
  canMigrate,
}: MigrateAccordionHeaderProps) => {
  const title = canMigrate
    ? "Este pessoa já está cadastrada no grupo econômico"
    : "O colaborador não pode ser migrado.";
  const description = canMigrate
    ? "Selecione o tipo de movimentação que você deseja fazer."
    : "Esse colaborador não pode ser migrado. Por favor, entre em contato com o suporte para mais informações sobre como proceder.";

  return (
    <Box gap="xs3" alignItems="center">
      <ShapeIcon
        name="IconAlertTriangle"
        variant="error"
        color="var(--color-feedback-error-50)"
        size={32}
        style={{ flexShrink: 0 }}
      />
      <div>
        <Typography.Headline10 color="neutral.20">
          {title}
        </Typography.Headline10>
        <Typography.Caption color="neutral.50">
          {description}
        </Typography.Caption>
      </div>
    </Box>
  );
};
